import { render, staticRenderFns } from "./gift-card.vue?vue&type=template&id=31caab68&scoped=true&"
import script from "./gift-card.vue?vue&type=script&lang=js&"
export * from "./gift-card.vue?vue&type=script&lang=js&"
import style0 from "./gift-card.vue?vue&type=style&index=0&id=31caab68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31caab68",
  null
  
)

export default component.exports